var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8375 10.1062L14.6437 5.9125C14.4375 5.6375 14.0938 5.5 13.75 5.5H8.25C7.49375 5.5 6.875 6.11875 6.875 6.875V19.25C6.875 20.0063 7.49375 20.625 8.25 20.625H17.875C18.6313 20.625 19.25 20.0063 19.25 19.25V11.0688C19.25 10.725 19.1125 10.3812 18.8375 10.1062ZM13.75 6.875L17.8062 11H13.75V6.875ZM8.25 19.25V6.875H12.375V11C12.375 11.7562 12.9938 12.375 13.75 12.375H17.875V19.25H8.25Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 12.375H2.75V2.75C2.75 1.99375 3.36875 1.375 4.125 1.375H13.75V2.75H4.125V12.375Z",
    fill: "#646464"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyPaper);
export default __webpack_public_path__ + "static/media/icon_copy_paper.ae96ec94.svg";
export { ForwardRef as ReactComponent };